import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Card, Container, Row, Col } from "react-bootstrap"
import { bmoApi } from '../../../api'
import { partnerApi } from '../../../api'; //added to call partner api
import _ from 'lodash'

class ExploreOperators extends Component {
    static propTypes = {
        currentOperatorID: PropTypes.number,
        token: PropTypes.string
    };
    static defaultProps = {
        currentOperatorID: 0,
        token: ""
    };


    constructor(props) {
        super();
        this.state = {
            operators: [],
            partnerobj:[] //added to store partner data
        }
    }

    componentWillMount = async () => {
        await this.setPartnersdata();
     }

    componentDidMount = async () => {

        const obj = {
            "posts_per_page": 4,
            "env": process.env.REACT_APP_MODE,
        }
        if (this.props.currentOperatorID > 0) {
            obj['ids_except'] = this.props.currentOperatorID;
        }

        const apiResponse = await bmoApi.searchBMOs(this.props.token, 1, obj);
        const respJson = await apiResponse.json();
        if (apiResponse.status === 200) {
            this.setState({ operators: respJson.result });
        } else {
            console.log(`error in bmos load`, respJson);
        }
    }

    //To fetch Partners data
        setPartnersdata = async() =>{
            let partnerdata = [];
            let partnersformdata = {
                "posts_per_page": 1000,
                "posts_status": ["publish"]
            }

        const partnersapiResponse =   await partnerApi.searchPartners(this.props.token, 1, partnersformdata);
        const partnersrespJson = await partnersapiResponse.json();
        if(partnersapiResponse.status === 200)
        {
            let partnerresultobj = {};
            partnerresultobj['result'] = partnersrespJson['data'];
            
            partnerresultobj['result'].map((data,index) => {
                const {post_title} = data
                partnerdata.push(post_title.toLowerCase());
            });
            this.state.partnerobj = partnerdata;
        }
    }   

    //To remove bridge and partner from Bmos
    removepartnerbridge()
    {
        if(this.state.operators != undefined)
        {
            this.state.operators.map((operatordata,bmoindex) => {
                const {name} = operatordata
                if(name.toLowerCase().startsWith('bridge') == true)
                {
                  this.state.operators.splice(bmoindex,1);
                }

                for (var i = 0; i < this.state.partnerobj.length; i++) {
                if(name.toLowerCase().startsWith(this.state.partnerobj[i]) == true)
                {
                   this.state.operators.splice(bmoindex,1);
                }
            }
            });
        }
    }


    render() {
        {this.removepartnerbridge()}
        const operators = this.state.operators

        return (
            <Container className="my-5 ">
                <Row>
                    <Col>
                        <h3>{`Explore more operators`}</h3>
                    </Col>
                </Row>
                <Row className="post-card-slider">
                    {operators.map(card => <Col sm="3" md="3">
                        <React.Fragment>
                            <div  className="post-card-box">
                                <a href={`/operators/${card.slug}`}>
                                    <img width="100%" src={card.logo ? card.logo.sizes.logo : ''} />
                                </a>
                            </div>
                            <div className="post-card-box-footer">
                                <p>{card.name}</p>
                            </div>
                        </React.Fragment>



                    </Col>)}
                </Row>
            </Container>
        )
    }
}

export default ExploreOperators